import React, { useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardBody,
  CardFooter,
  Grid,
  Heading,
  Text,
} from "grommet";
// import { redirect, useNavigate } from "react-router-dom";
import { digitalCourses } from "../../data/digitalCourses"; // Import the template data
import axios from "axios";
import { useState } from "react";
import { Trophy } from "grommet-icons";
import API_URL from "../../config/config";
export const DigitalLearningCourses = ({ user_id, assessment_id }) => {
  const [displayedCourses, setDisplayedCourses] = useState([]);
  useEffect(() => {
    try {
      const url = assessment_id
        ? `${API_URL}/dashboard/dashbronzeandgold/${user_id}/${assessment_id}`
        : `${API_URL}/dashboard/dashbronzeandgold/${user_id}`;
      axios.get(url).then((response) => {
        const flag = response.data.flag;
        console.log("Flag value:", flag);
        let courses;
        if (flag === 1) {
          console.log("Flag is 1");
          courses = digitalCourses.filter((course) => course.id === 2);
        } else if (flag === 2) {
          console.log("Flag is 2");
          courses = digitalCourses.filter(
            (course) => course.id === 2 || course.id === 3,
          );
        } else if (flag === 3) {
          console.log("Flag is 3");
          courses = [];
        } else {
          console.log("Flag is 0 or any other value");
          courses = digitalCourses.filter((course) => course.id === 3);
        }

        setDisplayedCourses(courses);
      });
    } catch (error) {
      console.error("Error fetching recommended paths:", error);
    }
  }, []);

  const handleCourseClick = () => {
    window.open(
      "https://education.hpe.com/ww/en/training/marketing/digital-learner-landing.html",
      "_blank",
    );
  };

  //   return (
  //     <Box pad="small" align="start" margin={{ bottom: "medium" }}>
  //       <Heading level="1" margin={{ top: "small", left: "small" }}>
  //         HPE Digital Learner subscription
  //       </Heading>
  //       {displayedCourses.length === 0 ? (
  //         <Text size="medium" margin={{ top: "small", left: "small" }}>
  //           We currently do not have a Digital Learner recommendation for your
  //           selected skill. Please check back later.
  //         </Text>
  //       ) : (
  //         <Box
  //           direction="row"
  //           gap="medium"
  //           margin={{
  //             top: "small",
  //             left: "small",
  //             right: "small",
  //             bottom: "medium",
  //           }}
  //           wrap // Allows it to wrap on smaller screens
  //           justify="between"
  //         >
  //           {/* Improved section with box and icons */}
  //           <Box
  //             pad="medium"
  //             background="light-2"
  //             round="small"
  //             flex={{ grow: 1, shrink: 1 }} // Flexible width
  //             border={{ color: "brand", size: "small" }}
  //           >
  //             {/* Icon and Text together */}
  //             <Box direction="row" align="center" gap="small">
  //               <Trophy size="large" color="brand" />
  //               <Heading level="3" margin="none" color="brand">
  //                 Unlock your learning experience with HPE Digital Learner
  //               </Heading>
  //             </Box>

  //             {/* Body text */}
  //             <Text size="medium" margin={{ top: "small" }}>
  //               To keep your skills sharp and drive further development, we’re
  //               pleased to offer these Digital Learner recommendations. <br />
  //               Dive into these resources to enhance your expertise and broaden
  //               your knowledge on a variety of topics.
  //             </Text>

  //             {/* Recommendation text */}
  //             <Text size="medium" margin={{ top: "small" }}>
  //               Continue your learning journey and unlock new insights!
  //             </Text>
  //           </Box>

  //           {/* Grid for displaying courses */}
  //           <Grid
  //             columns={{ count: 3, size: "small" }} // Three columns of equal size
  //             gap="medium"
  //             pad={{ horizontal: "small", vertical: "small" }}
  //             justify="center"
  //             flex={{ grow: 2, shrink: 1 }} // Makes the grid take up more space
  //           >
  //             {displayedCourses.map((course) => (
  //               <Card
  //                 key={course.id}
  //                 background={course.color}
  //                 height="small"
  //                 width="small"
  //                 pad="small"
  //               >
  //                 <CardBody>
  //                   <Box align="center" justify="around" direction="row" flex>
  //                     <course.icon size="xxlarge" />
  //                     <Heading
  //                       level="2"
  //                       margin={{ top: "small", bottom: "small" }}
  //                       textAlign="center"
  //                     >
  //                       {course.title}
  //                     </Heading>
  //                   </Box>
  //                 </CardBody>
  //                 <CardFooter pad={{ horizontal: "small" }} justify="center">
  //                   <Button
  //                     label="Learn more"
  //                     onClick={() => handleCourseClick()}
  //                     primary
  //                   />
  //                 </CardFooter>
  //               </Card>
  //             ))}
  //           </Grid>
  //         </Box>
  //       )}
  //     </Box>
  //   );

  return (
    <Box pad="small" align="start" margin={{ bottom: "medium" }}>
      <Heading level="1" margin={{ top: "small", left: "small" }}>
        HPE Digital Learner subscription
      </Heading>

      {/* Additional Recommendation Text */}
      <Text size="medium" margin={{ top: "xsmall", left: "small" }}>
        We recommend <b>HPE Digital Learner</b> to keep your skills refreshed
        and learn further skills 24/7x365 days.
      </Text>

      {displayedCourses.length === 0 ? (
        <Text size="medium" margin={{ top: "small", left: "small" }}>
          We currently do not have a Digital Learner recommendation for your
          selected skill. Please check back later.
        </Text>
      ) : (
        <Box
          direction="row"
          margin={{
            top: "small",
            left: "small",
            right: "small",
            bottom: "medium",
          }}
          wrap // Allows it to wrap on smaller screens
          justify="start"
        >
          {/* Improved section with box and icons */}
          <Box
            pad="medium"
            background="light-2"
            round="small"
            flex={{ grow: 1, shrink: 1 }} // Flexible width
            border={{ color: "brand", size: "small" }}
            width="full"
          >
            {/* Icon and Text together */}
            <Box direction="row" align="center" gap="small">
              <Trophy size="large" color="brand" />
              <Heading level="3" margin="none" color="brand">
                HPE Digital Learner subscription
                <br />
                Unlock your learning experience with HPE Digital Learner
              </Heading>
            </Box>

            {/* Body text */}
            <Text size="medium" margin={{ top: "small" }}>
              To keep your skills sharp and drive further development, consider
              subscribing to HPE Digital Learner. <br />
              Our online learning platform helps to accelerate your expertise
              and fits your busy schedule.
            </Text>

            {/* Recommendation text */}
            <Text size="medium" margin={{ top: "small" }}>
              Continue your learning journey and unlock new insights!
            </Text>
          </Box>

          {/* Grid for displaying courses */}
          <Grid
            columns={{ count: 3, size: "small" }} // Three columns of equal size
            gap="medium"
            pad={{ horizontal: "small", vertical: "small" }}
            justify="center"
            flex={{ grow: 2, shrink: 1 }} // Makes the grid take up more space
          >
            {displayedCourses.map((course) => (
              <Card
                key={course.id}
                background={course.color}
                height="small"
                width="small"
                pad="small"
              >
                <CardBody>
                  <Box align="center" justify="around" direction="row" flex>
                    <course.icon size="xxlarge" />
                    <Heading
                      level="2"
                      margin={{ top: "small", bottom: "small" }}
                      textAlign="center"
                    >
                      {course.title}
                    </Heading>
                  </Box>
                </CardBody>
                <CardFooter pad={{ horizontal: "small" }} justify="center">
                  <Button
                    label="Learn more"
                    onClick={() => handleCourseClick()}
                    primary
                  />
                </CardFooter>
              </Card>
            ))}
          </Grid>
        </Box>
      )}
    </Box>
  );
};
